import { render, staticRenderFns } from "./CreateSupplier.vue?vue&type=template&id=7f5c276e&"
import script from "./CreateSupplier.vue?vue&type=script&lang=js&"
export * from "./CreateSupplier.vue?vue&type=script&lang=js&"
import style0 from "./CreateSupplier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports